"use strict";
var mobileHeaderEl = document.getElementById('header-mobile');
var mobileHeaderAdjustEl = document.getElementById('header-adjust-mobile');
var mobileShowAfterEl = document.querySelector('[data-hide-header-until-after-scroll]');
var hideMobileHeader = function () {
    mobileHeaderEl.classList.remove('active');
};
var hideMobileHeaderAdjust = function () {
    mobileHeaderAdjustEl.style.display = 'none';
};
var showMobileHeader = function () {
    mobileHeaderEl.classList.add('active');
};
var showMobileHeaderAdjust = function () {
    mobileHeaderAdjustEl.style.display = 'block';
};
var checkForMobileHeaderReveal = function () {
    if (!mobileHeaderEl.classList.contains('active') && window.pageYOffset > mobileShowAfterEl.offsetTop + mobileShowAfterEl.offsetHeight) {
        showMobileHeader();
    }
    else if (mobileHeaderEl.classList.contains('active') && window.pageYOffset < mobileShowAfterEl.offsetTop) {
        hideMobileHeader();
    }
};
// ensure idempotency for this method because it will be called many times
var initMobileHeader = function () {
    // don't initialize header if no mobileHeaderEl exists (prevent errors in this function when '?showContentOnly=true' is present in url)
    if (!mobileHeaderEl)
        return;
    hideMobileHeader();
    hideMobileHeaderAdjust();
    if (mobileShowAfterEl && window.innerWidth >= window.breakpoints.large) {
        window.removeEventListener('scroll', checkForMobileHeaderReveal);
        window.addEventListener('scroll', checkForMobileHeaderReveal);
    }
    else {
        showMobileHeader();
        showMobileHeaderAdjust();
    }
};
// set a throttle to reinit after resize
var mobileHeaderResizeTimer;
var resetMobileHeaderResizeTimer = function () {
    clearTimeout(mobileHeaderResizeTimer);
    mobileHeaderResizeTimer = setTimeout(initMobileHeader, 100);
};
// init now and on resize
initMobileHeader();
window.addEventListener('resize', resetMobileHeaderResizeTimer);
